module.exports = __webpack_public_path__ + "static/media/FireWork.aa324b37.png";